import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-claimstatus',
  templateUrl: './claimstatus.component.html',
  styleUrls: ['./claimstatus.component.scss'],
})
export class ClaimstatusComponent implements OnInit {

  headerTitle: any;
  langcontext: any;
  Claimfrom: any;
  policynumber: any="";
  name: any="";
  formsubmitted: any;
  constructor(public platform: Platform, public navCtrl: NavController, public _sanitizer: DomSanitizer, public inappbrowser: InAppBrowser, public cmndecl: CommonDeclarationService,public formBuilder: FormBuilder, public api: RestapiService, public router: Router) {
    console.log(this.cmndecl.LanguageJson);
    this.Claimfrom = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      mobile: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8),
      ]))
    });
  }

  ngOnInit() {
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['claimstatus'];
      this.headerTitle = this.langcontext.heading.label;
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].claimstatus;
      this.headerTitle = this.langcontext.heading.label;
    }

    this.Claimfrom = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      policynumber: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(10),
      ]))
    });
    console.log(this.router.url);
  }

  validatefun(flg: any) {
    if (flg == 'name'){
      this.name = this.name.replace(/[^a-zA-Z ]+/g, '');
      this.name = this.name.replace("  ", ' ');
      console.log(this.name.length);
      if(this.name.length == 1)
        this.name = this.name.replace(" ", '');
    }
    else 
      this.policynumber = this.policynumber.replace(/[^0-9]/g, '');
  }

  openClaim(){
    let link: any = "https://www.pnbmetlife.com/wps/portal/metcustomer/intimateclaim?policyNo=";
    let req : any
    this.name = this.name.trim();
    if (this.Claimfrom.valid && this.name.length >=3) {
      link = link + this.policynumber+"&policyOwner="+this.name;
      console.log(link);
      req = {
        "policyOwnerName": this.name,
        "policyNumber": this.policynumber,
        "DeviceId": localStorage.pushToken || ""
      }
      this.api.clickenventcap("intimateClaimProceedButton");
      this.api.postapi("setClaimClickEvent",req).then(data=>{
        console.log(data);
      },err=>{
        console.log(err);
      })
      if(this.cmndecl.BrowserBuild != 1)
        this.inappbrowser.create(link,"_blank");
      else
        window.open(link,"_blank");
      if(this.router.url != "/claimlogin")
         this.navCtrl.navigateRoot("/preRegister");
    }
  }
}
